import React, {Component} from 'react';
import SAInputComponent from "../common/input/SAInputComponent";
import {Switch} from "antd";
import SADatePicker from "../common/input/SADatePicker";
import {injectIntl} from "react-intl";

class ActiveDateSelect extends Component {

  onActivate = e => {
    const {data = {}, onChange} = this.props;
    data.active = e;
    onChange(data);
  };

  onStartChange = e => {
    const {data = {}, onChange} = this.props;
    data.from = e;
    onChange(data);
  };

  onEndChange = e => {
    const {data = {}, onChange} = this.props;
    data.to = e;
    onChange(data);
  };

  render() {
    const {intl: {formatMessage}, data: {from, to, active} = {}, errors = {}} = this.props;
    return (
      <div className="row">
        <div className="col-md-4 col-xxl-4">
          <SAInputComponent label={formatMessage({id: "active"})} error={errors.active}>
            <Switch checked={active} onChange={this.onActivate}/>
          </SAInputComponent>
        </div>
        <div className="col-md-4 col-xxl-4">
          <SAInputComponent label={formatMessage({id: "placeholder.startDate"})} >
            <SADatePicker placeholder={formatMessage({id: "placeholder.startDate"})} value={from} onChange={this.onStartChange} error={errors.from} />
          </SAInputComponent>
        </div>
        <div className="col-md-4 col-xxl-4">
          <SAInputComponent label={formatMessage({id: "placeholder.endDate"})} >
            <SADatePicker placeholder={formatMessage({id: "placeholder.endDate"})} value={to} onChange={this.onEndChange} error={errors.to}/>
          </SAInputComponent>
        </div>
      </div>
    )
  }
}

export default injectIntl(ActiveDateSelect);



// WEBPACK FOOTER //
// ./src/components/communication/ActiveDateSelect.js